import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import styles from './style.less';
import chevronLeft from '../../../assets/icons/svg/chevron_left.svg';
import chevronRight from '../../../assets/icons/svg/chevron_right.svg';
import dayjs from 'lib/helpers/dayjs';
import { I18n } from "components/elements";

const Calendar = (props) => {
  const {selectedDateAction}= props;
  const startDate = props.startDate ?  props.startDate : dayjs();
  const currentDate = dayjs();

  const [controlDate, setControlDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(startDate.format());
  const [days, setDays] = useState([]);
  const [day, setDay] = useState(startDate.date());
  const [month, setMonth] = useState(startDate.month());
  const [year, setYear] = useState(startDate.year());

  const daysOfWeek = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const displayYear = year !== startDate.year() ? year : '';

  const generateCalendar = (date) => {
    const numDays = dayjs(date).daysInMonth();
    const startDay = dayjs(date).date(1).day();
    const days = [];

    const adjustedStartDay = (startDay === 0) ? 6 : startDay - 1;

    for (let i = 0; i < adjustedStartDay; i++) {
      days.push(null);
    }

    for (let i = 1; i <= numDays; i++) {
      const dayDate = dayjs(date).date(i);
      const isDisabled = dayDate.isBefore(currentDate, 'day');
      days.push({ day: i, isDisabled });
    }
    return days;
  };


  const isSelectedDate = (dayItem) => {
    if (!dayItem || !dayItem.day) return false;
    return dayjs(selectedDate).isSame(dayjs(controlDate).date(dayItem.day), "date");
  };


  const handlePrevMonth = () => {
    const newDate = dayjs(controlDate).subtract(1, 'month');
    const numDaysInNewMonth = newDate.daysInMonth();
    if (day > numDaysInNewMonth) {
      setDay(numDaysInNewMonth);
    }
    setMonth(newDate.month());
    setYear(newDate.year());
  };

  const handleNextMonth = () => {
    const newDate = dayjs(controlDate).add(1, 'month');
    const numDaysInNewMonth = newDate.daysInMonth();
    if (day > numDaysInNewMonth) {
      setDay(numDaysInNewMonth);
    }
    setMonth(newDate.month());
    setYear(newDate.year());
  };

  
  const selectDay = (dayItem) => {
    if (dayItem && !dayItem.isDisabled) {
      const newDate = dayjs().year(year).month(month).date(dayItem.day);
      setSelectedDate(newDate.format());

      if (selectedDateAction) {
        selectedDateAction(newDate);
      }
    }
  };

  useEffect(() => {
    if (day !== null && month !== null && year !== null) {
      const newDate = dayjs().year(year).month(month).date(day);
      setControlDate(newDate.format());
    }
  }, [day, month, year]);

  useEffect(() => {
    if (controlDate) {
      const days = generateCalendar(controlDate);
      setDays(days);
    }
  }, [controlDate]);

  return (
    <div className={styles.calendar}>
      <div className={styles.header}>
        <button onClick={handlePrevMonth}>
          <img src={chevronLeft} alt="Previous month" />
        </button>
        {month !== null && (
          <div>
            <I18n>{months[month].substring(0, 3).toLocaleLowerCase()}</I18n> {displayYear}
          </div>
        )}
        <button onClick={handleNextMonth}>
          <img src={chevronRight} alt="Next month" />
        </button>
      </div>
      <div className={styles.daysOfWeek}>
        {daysOfWeek.map(day => (
          <div key={day} className={styles.dayOfWeek}><I18n>{day}</I18n></div>
        ))}
      </div>
      <div className={styles.days}>
        {days.map((dayItem, index) => {
          const styleSelected = isSelectedDate(dayItem) ? styles.currentDay : '';
          const styleDisabled = !dayItem || dayItem.isDisabled ? styles.disabledDay : '';
          const dynamicStyle = `${styles.day} ${styleDisabled} ${styleSelected}`;

          return <div
            key={index}
            className={dynamicStyle}
            onClick={() => dayItem && !dayItem.isDisabled && selectDay(dayItem)}
          >
            <span>{dayItem ? dayItem.day  : ""}</span>
          </div>
        })}
      </div>
    </div>
  );
};

export default Calendar;


// WEBPACK FOOTER //
// ./components/elements/Calendar/index.js